import { render } from "./ClientManagement.vue?vue&type=template&id=2479e7c2&scoped=true"
import script from "./ClientManagement.vue?vue&type=script&lang=js"
export * from "./ClientManagement.vue?vue&type=script&lang=js"

import "./ClientManagement.vue?vue&type=style&index=0&id=2479e7c2&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2479e7c2"]])

export default __exports__